import React, { FC, PropsWithChildren, createContext, useContext } from 'react';

import { UserContext } from '../UserContext';
import { WizardContext } from 'vibo-ui/Wizard/WizardStepContext';

import { authStorage } from 'utils/helpers/auth';
import { useEventColor } from 'graphql/hooks/event';

import { DeepLinkWizardSteps } from 'components/common/DeepLinkWizard/interfaces';
import { HeadingWithImageData } from 'components/common/HeadingWithImage/interfaces';

type TDeepLinkContext = {
  action?: Nullable<Function>;
  goLogin?: Function;
  previewData?: HeadingWithImageData;
};

export const DeepLinkContext = createContext<TDeepLinkContext>(undefined!);

export const useDeepLink = () => useContext(DeepLinkContext);

export const DeepLinkContextProvider: FC<PropsWithChildren<TDeepLinkContext>> = ({
  action,
  children,
  previewData,
}) => {
  const wizard = useContext(WizardContext);
  const { isLoggedIn } = useContext(UserContext);

  const goLogin = () => {
    wizard?.wizardRefProps?.goToNamedStep(DeepLinkWizardSteps.login);
  };

  useEventColor({
    event: previewData as EventItem,
    isBrandingAllowed: previewData?.isBrandingAllowed,
  });

  return (
    <DeepLinkContext.Provider
      value={{
        goLogin,
        previewData,
        action: () => {
          if (!!action && (isLoggedIn || !!authStorage.token)) {
            action();
          } else {
            goLogin();
          }
        },
      }}
    >
      {children}
    </DeepLinkContext.Provider>
  );
};
